import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["url", "thumbnailUrl", "preview", "placeholder", "status"]

  connect() {
    this.update()
  }

  update() {
    const customThumbnailValue = this.thumbnailUrlTarget.value.trim()
    const customThumbnailUrl = this.validHttpUrl(customThumbnailValue)
    const shortcutUrl = this.validHttpUrl(this.urlTarget.value)

    if (customThumbnailValue && !customThumbnailUrl) {
      this.hidePreview("Enter a valid HTTP or HTTPS thumbnail URL.")
      return
    }

    const previewUrl = customThumbnailUrl?.href || this.faviconUrl(shortcutUrl)

    if (!previewUrl) {
      this.hidePreview("Enter a valid shortcut URL to preview its favicon.")
      return
    }

    this.previewTarget.classList.add("hidden")
    this.placeholderTarget.classList.remove("hidden")
    this.previewUrl = previewUrl
    this.previewTarget.src = previewUrl
    this.statusTarget.textContent = customThumbnailUrl
      ? "Loading custom thumbnail…"
      : "Loading favicon from shortcut URL…"
  }

  loaded(event) {
    if (event.currentTarget.src !== this.previewUrl) return

    this.previewTarget.classList.remove("hidden")
    this.placeholderTarget.classList.add("hidden")
    this.statusTarget.textContent = this.thumbnailUrlTarget.value.trim()
      ? "Custom thumbnail preview"
      : "Favicon preview"
  }

  failed(event) {
    if (event.currentTarget.src !== this.previewUrl) return

    this.hidePreview("Thumbnail could not be loaded. Try a different thumbnail URL.")
  }

  faviconUrl(url) {
    return url ? `${url.origin}/favicon.ico` : null
  }

  validHttpUrl(value) {
    if (!value.trim()) return null

    try {
      const url = new URL(value)
      if (!["http:", "https:"].includes(url.protocol) || url.username || url.password) return null

      return url
    } catch (_) {
      return null
    }
  }

  hidePreview(message) {
    this.previewUrl = null
    this.previewTarget.classList.add("hidden")
    this.placeholderTarget.classList.remove("hidden")
    this.previewTarget.removeAttribute("src")
    this.statusTarget.textContent = message
  }
}
